import * as React from "react";
import { ChevronsUpDown, ChevronsDownUp } from "lucide-react";
import { cn } from "../../lib/utils";
const PanelSwitcher = ({ open, onToggle, children, }) => {
    const [isOpen, setIsOpen] = React.useState(open);
    return (React.createElement("div", { className: `${isOpen ? "bg-skvegreen-400" : "bg-muted hover:bg-popover"} p-1 rounded cursor-pointer`, onClick: () => {
            setIsOpen(!isOpen);
            onToggle(!isOpen);
        } }, children));
};
/**
 * @example
 *
 * ```jsx
 * import { PanelComponent, Legend, LegendEntryComponent } from "@skve/components";
 * import { ChartCandlestick } from "lucide-react";
 * import { ChartNoAxesCombined } from "lucide-react";
 *
 * function Demo() {
 *   const switches = [
 *     {
 *       key: "Messwerte",
 *       name: "Messwerte",
 *       icon: ChartCandlestick,
 *       isOpen: false,
 *       onToggle: () => {}
 *     },
 *     {
 *       key: "Prognose",
 *       name: "Prognose",
 *       icon: ChartNoAxesCombined,
 *       isOpen: true,
 *       onToggle: () => {}
 *     }
 *   ];
 *
 *   const legendEntry1 = {
 *    name: "Störung",
 *    xValue: "3.7. 11:30 - 5.7. 15:45",
 *    yValue: "0 - 0",
 *    unit: "kW",
 *    color: "purple",
 *    extension: null
 *   };
 *
 *   const legendEntry2 = {
 *    name: "Wärme",
 *    xValue: "1.7. 14:30 - 2.7. 15:45",
 *    yValue: "300 - 500",
 *    unit: "kW",
 *    color: "grey",
 *    extension: null
 *   };
 *
 *   const legendEntry3 = {
 *    name: "Wärme",
 *    xValue: "1.7. 14:30 - 2.7. 15:45",
 *    yValue: "300 - 500",
 *    unit: "kW",
 *    color: "yellow",
 *    extension: null
 *   };
 *
 *   const legendEntryComponent1 = <LegendEntryComponent {...legendEntry1} />;
 *   const legendEntryComponent2 = <LegendEntryComponent {...legendEntry2} />;
 *   const legendEntryComponent3 = <LegendEntryComponent {...legendEntry3} />;
 *   const legendEntries = [legendEntryComponent1, legendEntryComponent2, legendEntryComponent3];
 *   const legend = <Legend legendHeight={76} legendEntries={legendEntries} />;
 *   const children = <div className="w-full h-full bg-blue-700 " />;
 *   return <PanelComponent chartName="Gesamt" legend={legend} switches={switches} hideCollapse={false}>{children}</PanelComponent>;
 * }
 * ```
 */
const PanelComponent = ({ chartName, chartHeight, children, legend, switches, buttons, isLast, isCollapsed, hideCollapse, noBorder, onToggleHeight, }) => (React.createElement("div", { className: "flex flex-row w-full h-full mb-4 last:mb-0 gap-2 px-2 chartsframe__panel" },
    chartName || (switches === null || switches === void 0 ? void 0 : switches.length) || legend ? (React.createElement("div", { className: "chartsframe__legend" },
        React.createElement("div", { className: "flex flex-row justify-between" },
            React.createElement("div", { className: "flex flex-row gap-4" },
                React.createElement("div", { className: "text-base" }, chartName),
                React.createElement("div", { className: "flex flex-row items-center gap-2" }, switches === null || switches === void 0 ? void 0 :
                    switches.map((s) => (React.createElement(PanelSwitcher, { key: s.key, open: s.isOpen, onToggle: s.onToggleOpen },
                        React.createElement(s.icon, { className: "h-4 w-4" })))), buttons === null || buttons === void 0 ? void 0 :
                    buttons.map((button, i) => (React.createElement(React.Fragment, { key: i }, button))))),
            !hideCollapse && (React.createElement("div", { className: "flex flex-row items-center gap-2" }, !isCollapsed ? (React.createElement("div", { className: `bg-muted p-1 rounded cursor-pointer hover:bg-popover` },
                React.createElement(ChevronsDownUp, { className: "h-4 w-4", onClick: () => onToggleHeight === null || onToggleHeight === void 0 ? void 0 : onToggleHeight() }))) : (React.createElement("div", { className: `bg-muted p-1 rounded cursor-pointer hover:bg-popover` },
                React.createElement(ChevronsUpDown, { className: "h-4 w-4", onClick: () => onToggleHeight === null || onToggleHeight === void 0 ? void 0 : onToggleHeight() })))))),
        React.createElement("div", { className: "chartsframe__series thin-scrollbar" }, legend))) : (React.createElement("div", null)),
    React.createElement("div", { className: cn("w-full", chartHeight, noBorder ? "px-0.5" : "p-0.5", noBorder && isLast && "pb-0.5", !noBorder && !isLast && "pb-0") }, children)));
PanelComponent.displayName = "PanelComponent";
export { PanelComponent };
//# sourceMappingURL=panelComponent.js.map